module.exports = __webpack_public_path__ + "img/bottles.fd97a27a.png";